let counter = 0;
const MAX_VALUE = Number.MAX_SAFE_INTEGER || 9007199254740991;

function generate(prefix) {
    counter++;

    if (counter >= MAX_VALUE) {
        counter = 0;
    }

    return `${prefix}_uid-${counter}`;
}

function setCounter(val) {
    counter = val;
}

const exported = {
    generate,
    _setCounter: setCounter,
};

export default exported;
export { generate, setCounter as _setCounter };
